import React from 'react'
import { ProcessingIndicator } from '../../../../ProcessingIndicator'
const MemberItem = ({
  member,
  onSelectMember,
  checked,
  mode,
  disabled,
  loggedInPoPmDaimlerId,
}) => {
  const content = (
    <div
      className="wb-margin-bottom-xxs"
      style={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }}
    >
      <div>
        <div className="wb-type-copy-tertiary">
          {member.firstName} {member.lastName}
        </div>
        <div className="wb-type-hint">{member.email}</div>
        <div className="wb-type-hint">{member.daimlerId}</div>
      </div>
      <div className="wb-margin-start-xxs">
        {disabled ? <ProcessingIndicator /> : null}
      </div>
    </div>
  )
  if (mode === 'edit') {
    return content
  }
  return (
    <wb-checkbox-control class="wb-margin-bottom-xs">
      <label>
        <input
          type="checkbox"
          name={member.id}
          checked={checked}
          disabled={disabled || loggedInPoPmDaimlerId === member.daimlerId}
          onChange={() => onSelectMember(member)}
        />
        {content}
        {loggedInPoPmDaimlerId === member.daimlerId ? (
          <wb-control-error id="IdOfError">
            You cannot assign permission to yourself. Please contact other PO or
            PM
          </wb-control-error>
        ) : null}
      </label>
    </wb-checkbox-control>
  )
}

export default MemberItem
